import * as Yup from 'yup';
import { Path } from 'react-hook-form';
import { NewOutboundShipmentFormValues } from './types';

// Step 1: Products Load validation
const step1Schema = Yup.object().shape({
  selectedProducts: Yup.array()
    .min(1, 'At least one product must be selected')
    .test(
      'has-selected-products',
      'At least one product must be selected',
      (value) => {
        if (!value) return false;
        return value.some((product) => product.isSelected);
      }
    ),
});

// Step 2: Shipment Details validation
const step2Schema = Yup.object().shape({
  purchaseOrderNumber: Yup.string().required(
    'Purchase order number is required'
  ),
  shipmentId: Yup.string().required('Shipment ID is required'),
  originWarehouse: Yup.string().required('Origin warehouse is required'),
  client: Yup.string().required('Client is required'),
  desiredPickupDate: Yup.string().required('Desired pick-up date is required'),
  desiredDeliveryDate: Yup.string().required(
    'Desired delivery date is required'
  ),
  dropoffAccessRestrictions: Yup.string().required(
    'Access restrictions is required'
  ),
  dropoffSecurityInduction: Yup.string().required(
    'Security / ID / Induction is required'
  ),
  dropoffPreBooking: Yup.string().required('Pre-booking information is required'),
  shipmentMethod: Yup.string().required('Shipment method is required'),
  preferredVehicle: Yup.string().required('Preferred vehicle is required'),
  curtainSideOrBoxBody: Yup.string().required(
    'Curtain-side or box body preference is required'
  ),
  tailLiftRequired: Yup.string().required('Tail-lift selection is required'),
  moffettRequired: Yup.string().required(
    'Moffett/forklift selection is required'
  ),
});

// Step 3: Route validation (placeholder)
const step3Schema = Yup.object().shape({});

// Step 4: Confirmation validation (placeholder)
const step4Schema = Yup.object().shape({});

// Array of schemas indexed by step (0-based)
export const schemas = [step1Schema, step2Schema, step3Schema, step4Schema];

// Step field mapping for FormPage validation (1-indexed to match currentStep)
export const stepFields: Record<number, Path<NewOutboundShipmentFormValues>[]> =
  {
    1: ['selectedProducts'],
    2: [
      'purchaseOrderNumber',
      'shipmentId',
      'originWarehouse',
      'client',
      'desiredPickupDate',
      'desiredDeliveryDate',
      'dropoffAccessRestrictions',
      'dropoffSecurityInduction',
      'dropoffPreBooking',
      'shipmentMethod',
      'preferredVehicle',
      'curtainSideOrBoxBody',
      'tailLiftRequired',
      'moffettRequired',
    ],
    3: [],
    4: [],
  };
